import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  Optional,
  ViewChild,
} from "@angular/core";
import { NguCarousel, NguCarouselConfig } from "@ngu/carousel";
import {
  IAppDataStore,
  IAuthorizationService,
  IContextService,
  PershingTranslationService,
} from "@pershing/pershing-core";
import { BalancesService } from "../../services/balances.services";
import { UnRealizedGainLossService } from "../../services/unrealized.gainloss.service";
import { BalancesConstants } from "../../utils/balances-constants";
import { BehaviorSubject, Subscription, interval } from "rxjs";
import { GainLossConstants } from "../../utils/gainloss.constants";
@Component({
  selector: "overview-summary",
  templateUrl: "./overview-summary.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverviewSummaryComponent implements OnInit, OnDestroy {
  balancesResponseSub: any;
  balancesDataSummary: any;
  totalValue;
  gainlossResponse: any;
  carouselItems: any = [];
  defaultValue: any = 0;
  allAccountList: any = [];
  accountList: any = [];
  accountNumber: string;
  balancesUri = "/groups/";
  moneyLine = false;
  groupSummary = true;
  marginRequired: boolean = true;
  ibd: any;
  isAuthorizedForGainLoss: boolean = true;
  isAuthorizedForAvailableToTrade: boolean = true;
  
  isGroupAcc: boolean = true;
  isBrokarageAcc: boolean = true;
  quoteType: string = GainLossConstants.DELAYED;
  isLoading = new BehaviorSubject(true); //0 is the initial value.
  loading: boolean = true;
  isLoadingForBalances = new BehaviorSubject(true);
  loadingBalances: boolean = true;

  isGainLossLoaded = new BehaviorSubject(false);
  loadingGainLoss: boolean = true;
  points = [];
  isTablet:boolean=false;
  isErrorOccured= new BehaviorSubject(false);
  balancesOverviewSubscription: Subscription;
  gainLossSubscription: Subscription;

  @ViewChild("myCarousel") myCarousel: NguCarousel;

  carouselConfig: NguCarouselConfig = {
    grid: { xs: 2, sm: 2, md: 2, lg: 1, all: 0 },
    load: 2,
    interval: { timing: 3000, initialDelay: 1000 },
    loop: true,
    velocity: 0.2,
    point: {
      visible: true,
      hideOnSingleSlide: true,
    },
  };

  constructor(
    private translationService: PershingTranslationService,
    private balancesService: BalancesService,
    private gainLossService: UnRealizedGainLossService,
    private authorizationService: IAuthorizationService,
    private appDataStore: IAppDataStore,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    @Optional() @Inject("AppSettings") appSettings: any
  ) {
    translationService.addTranslationFolder(
      "@pershing/nxi-ng-balances",
      "node_modules/@pershing/nxi-ng-balances/lib"
    );
  
    this.ibd = appSettings.ibdConfigMap.IBD;
    if (appSettings.deviceType && appSettings.deviceType === "tablet") {
      this.carouselConfig.grid.lg=2;
    }
    this.checkEntitlements(); 
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }


  ngOnInit(): void {
    let count = 0;
    let sub = interval(1000).subscribe((val => {
      if(count == 5){
        sub.unsubscribe();
        this.isLoading.next(false);
        console.log("Error occured trying to call api one more time ");
      }
      if(this.appDataStore.get("ACCOUNTS_LIST") != null) {
        this.allAccountList = this.appDataStore.get("ACCOUNTS_LIST");
        sub.unsubscribe();
        this.isLoading.next(false);
        this.isLoading.subscribe((res) => {
                this.loading = res;
              });
        this.setAccountsList();
      }
      count++;
    }))
  }

  setAccountsList() {
    if (this.allAccountList.length > 0) {
       this.isErrorOccured.next(false);
       this.isGainLossLoaded.subscribe((res) => {
       this.loadingGainLoss = res;
      });
      this.isLoadingForBalances.subscribe((res) => {
        this.loadingBalances = res;
      });

      this.accountList = this.allAccountList.filter(this.extractAccounts);
      if (this.accountList.length > 1 && this.accountList.length != 1) {
        this.accountNumber =
          this.ibd + "_" + this.allAccountList[0].groupId + "_C";
        this.isGroupAcc = true;
      } else if (this.accountList.length == 1) {
        this.accountNumber = this.accountList[0].acctNo;
        this.balancesUri = "/accounts/";
        this.moneyLine = true;
        this.groupSummary = false;
        this.isGroupAcc = false;
        if (this.accountList[0]["custodianCode"] == "PLLC") {
          this.isBrokarageAcc = true;
        } else {
          this.isBrokarageAcc = false;
        }
      }
      this.getOverviewBalances();
    }
  }
  

  getOverviewBalances() {
      if(this.appDataStore.get('BALANCES') != null){
        let res = this.appDataStore.get('BALANCES');
        this.isLoadingForBalances.next(false);
        this.balancesDataSummary = res["response"]["balances"];
        this.totalValue =
          res["response"]["balances"]["balancesSummary"]["totalWorth"][
            "value"
          ];
        this.balancesService.dispatchOverviewBalance(res);
        this.processCarouselData(this.balancesDataSummary);
      }else{
        this.balancesOverviewSubscription = this.balancesService.getBalanceForOverview(
          this.accountNumber,
          BalancesConstants.DELAYED,
          this.balancesUri,
          this.marginRequired,
          this.moneyLine,
          this.groupSummary
        )
        .subscribe((res) => {
          this.ngZone.run(() => {
            this.isLoadingForBalances.next(false);
            this.balancesService.fetchingBalancesData$.next(false);
            this.appDataStore.put('BALANCES',res);
            this.balancesDataSummary = res["response"]["balances"];
            this.totalValue =
              res["response"]["balances"]["balancesSummary"]["totalWorth"][
                "value"
              ];
            this.balancesService.dispatchOverviewBalance(res);
            this.processCarouselData(this.balancesDataSummary);
          });
        },err=>{
          this.isLoadingForBalances.next(false);
          this.balancesService.fetchingBalancesData$.next(false);
          this.isErrorOccured.next(true);
        });
      }
      this.getUGLResponse();
  }

  extractAccounts(item) {
    return item.acctNo != null && item.acctNo != "ALL";
  }

  processUglData(gainlossResponse) {
    if (gainlossResponse != null) {
      let item = {
        key: gainlossResponse.totalGainLoss >= 0 ? "OVERVIEW_SUMMARY.UNREALIZED_GAIN" :"OVERVIEW_SUMMARY.UNREALIZED_LOSS",
        value: gainlossResponse.totalGainLoss
          ? gainlossResponse.totalGainLoss
          : this.defaultValue,
        info: this.isGroupAcc ? "OVERVIEW_SUMMARY.UNREALIZED_GAIN_INFO" : false,
        titleClass: "ovr-Balances_Ugltxt",
        valueClass: "ovr-Balances_Uglvalue",
        ddClass: gainlossResponse.totalGainLoss >= 0 ? "positive" : "negative",
        position: 2,
        display: this.isAuthorizedForGainLoss,
      };
      this.carouselItems.push(item);
      this.sort();
    }
  }

  processCarouselData(data) {
    let balancesSummary = data["balancesSummary"];
    let balancesDetails = data["balancesDetails"];
    let summary = {
      key: "OVERVIEW_SUMMARY.TODAY",
      value: balancesSummary.totalWorth?.difference
        ? balancesSummary.totalWorth.difference
        : this.defaultValue,
      titleClass: "ovr-Balances_Today",
      valueClass: "ovr-Balances_Todayvalue",
      ddClass:
        balancesSummary.totalWorth?.difference >= 0 ? "positive" : "negative",
      iconClass:
        balancesSummary.totalWorth?.difference >= 0
          ? "fa fa-arrow-up"
          : "fa fa-arrow-down",
      position: 1,
      display: true,
    };
    let availCash = {
      key: "OVERVIEW_SUMMARY.AVAILABLE_CASH",
      info: "OVERVIEW_SUMMARY.AVAILABLE_CASH_INFO",
      value: balancesSummary.fundsAvailableToWithdraw
        ? balancesSummary.fundsAvailableToWithdraw
        : this.defaultValue,
      titleClass: "ovr-Balances_AvailCash",
      valueClass: "ovr-Balances_AvailCashVal",
      position: 3,
      display: true,
    };

    this.carouselItems.push(summary);
    this.carouselItems.push(availCash);

    if (this.getAvailaleToTrade()) {
      this.carouselItems.push({
        key: "OVERVIEW_SUMMARY.AVAILABLE_CASH_TO_TRADE",
        info: "BALANCES.AVAILABLETOTRADEINFO",
        value: balancesSummary.fundsAvailableToTrade
          ? balancesSummary.fundsAvailableToTrade
          : this.defaultValue,
        titleClass: "ovr-Balances_AvailCash",
        valueClass: "ovr-Balances_AvailCashVal",
        position: 4,
        display: true,
      });
    } else if (this.getTrade()) {
      this.carouselItems.push({
        key: "OVERVIEW_SUMMARY.LONG_MARKET_VALUE",
        info: "OVERVIEW_SUMMARY.LONG_MARKET_VALUE_INFO",
        value: balancesDetails?.longMarketValue?.value
          ? balancesDetails?.longMarketValue?.value
          : this.defaultValue,
        titleClass: "ovr-Balances_AvailToTrade",
        valueClass: "ovr-Balances_AvailTrdeValue",
        position: 4,
        display: true,
      });
    }
    this.sort();
  }

  getTrade(): boolean {
    return (
      (this.isGroupAcc && !this.isAuthorizedForAvailableToTrade) ||
      (!this.isGroupAcc &&
        this.isBrokarageAcc &&
        !this.isAuthorizedForAvailableToTrade) ||
      (!this.isGroupAcc && !this.isBrokarageAcc)
    );
  }

  getAvailaleToTrade(): boolean {
    return (
      (this.isGroupAcc && this.isAuthorizedForAvailableToTrade) ||
      (!this.isGroupAcc &&
        this.isAuthorizedForAvailableToTrade &&
        this.isBrokarageAcc)
    );
  }

  sort() {
    this.carouselItems.sort((a, b) => a.position - b.position);
  }

  checkEntitlements() {
    console.log('checking entitlement for overview summary', this.authorizationService, '    ', this.authorizationService.isEntitled("GAIN_LOSS"));
    this.isAuthorizedForGainLoss = this.authorizationService.isEntitled("GAIN_LOSS");
    this.isAuthorizedForAvailableToTrade = this.authorizationService.isEntitled(
        "STOCK_TRADING || OPTIONS_TRADING || MUTUAL_FUND_TRADING || TRADING_529_FUND"
      );
  }

  getUGLResponse() {
    this.gainLossService.invokeUglService(
      this.accountNumber,
      "",
      "",
      this.quoteType,
      "",
      this.balancesUri
    );

    this.gainLossSubscription = this.gainLossService.ugl$.subscribe((uglSummaryResp) => {
      this.ngZone.run(() => {
        console.log(uglSummaryResp)
        if (!!uglSummaryResp && !!uglSummaryResp.uglTotal) {
          this.isGainLossLoaded.next(true);
          console.log("Second time",uglSummaryResp)
          this.gainlossResponse = uglSummaryResp.uglTotal;
          this.isGroupAcc = !(
            uglSummaryResp.accountEntity &&
            uglSummaryResp.accountEntity != null
          );
          this.processUglData(uglSummaryResp.uglTotal);
        }
      });
    },err=>{
      this.isGainLossLoaded.next(false);
      this.isErrorOccured.next(true);
    });
  }

  ngOnDestroy() {
    if (this.gainLossSubscription) {
      this.gainLossSubscription.unsubscribe();
    }
    if (this.balancesOverviewSubscription) {
      this.balancesOverviewSubscription.unsubscribe();
    }
  }

}
